import { MouseEvent } from "react";

type Callback = () => void;

export function useSmoothScroll() {
  return (e: MouseEvent<HTMLAnchorElement>, href: string, callback?: Callback) => {
    e.preventDefault();

    const id = href.replace("#", "");
    const elemento = document.getElementById(id);

    if (elemento) {
      elemento.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }

    if (callback) callback();
  };
}
